module.exports = __webpack_public_path__ + "static/media/agent-active.c3a35278.svg";